import { getDataUTC } from '@portal-internet/core';
import { getTimeFromNow, getHora } from 'utils/3catinfo/dateHelper';
import styles from './momentsclau.module.scss';

const MomentClau = (props) => {
    const { titol, data_publicacio, onClick, finalitzat, index } = props;

    return (
        <div className={styles.moment_clau}>
            {/* PENDENT DESENVOLUPAR */}
            <button className={styles.content} onClick={onClick} data-moment-clau={index}>
                <time className={styles.time_minut} dateTime={getDataUTC(data_publicacio)}>
                    <span>
                        {finalitzat ? getHora(data_publicacio) : getTimeFromNow(data_publicacio)?.replace('minuts', 'min.')}
                    </span>
                </time>

                <div className={styles.titol} dangerouslySetInnerHTML={{ __html: titol }}></div>
            </button>
        </div>
    );
};

export default MomentClau;
